import React from 'react'
// Returns the header for the html page
export default function Header() {
    return (
            <nav id='header'>
                <li className='text-center'>
                    TO-DO LIST
                </li>
            </nav>

    )
}
